import { ItemRecord } from '@controladad/ng-base';
import { BannerStatus, BannerType, BlogStatus } from '@repo/types';

export const EnableValues: ItemRecord<boolean>[] = [
  { value: true, label: 'Enable' },
  { value: false, label: 'Disable' },
];
export const CommonStatusValues: ItemRecord<BannerStatus>[] = [
  { value: 1, label: 'Enabled' },
  { value: 0, label: 'Disabled' },
];

export const BlogStatusValues: ItemRecord<BlogStatus>[] = [
  { value: 1, label: 'Enabled' },
  { value: 0, label: 'Disabled' },
];

export const BannerTypeValues: ItemRecord<BannerType>[] = [
  { value: 0, label: 'Category' },
  { value: 1, label: 'Product' },
  { value: 2, label: 'Tag' },
];
